<template lang="html">
  <div class="main-container">
      <div class="searchclass margin-bot-22">
        <breadcrumb :list="breadcrumbList" />
        <tl-header type="h1">
          <div class="main-header margintop-30">Add New Claim</div>
        </tl-header>
        <pop-up-message
          v-if="showSuccessBulkUploadMsg"
          message="Bulk Upload Successful"
          btnText="Back"
          @back="backUpload"
        ></pop-up-message>
        <toast-message
          :message="errmsg"
          :isToastEnable="toast"
          type="error"
          @close="(val) => toast = val"
        />
        <div class="uploadMethoRadio">
          <tl-radio
            name="uploadType"
            label="Manual"
            id="manualUpload"
            value="manualUpload"
            v-model="uploadMethod"
          />
          <tl-radio
            name="uploadType"
            label="Bulk Upload"
            id="bulkUpload"
            value="bulkUpload"
            v-model="uploadMethod"
          />
        </div>
        <div v-if="uploadMethod == 'manualUpload'">
          <br />
          <div class="block-width-no-use" :disabled="!(ifAdmin || ifHr)">
            <search-dropdown v-if="!showEmpDetails"
                placeholder="Search Employee"
                :employeeData="employeeData"
                :clearRequired="true"
                @getList="searchEmployeesByName($event)"
                @empselected="(emp)=>selectedEmp(emp)"/>
          </div>
        </div>
          <selected-employee-card v-if="showEmpDetails && uploadMethod == 'manualUpload'"
            :empName="data.first_name"
            :empId="data.code"
            :dates="data.rlopdates"
            :empMail="data.email_id"
            @click="close">
            <template v-slot:rowcontent="slotprops">
            </template>
          </selected-employee-card>
      </div>
      <div v-if="showEmpDetails && uploadMethod == 'manualUpload'">
        <div class="add-btn-small">
          <button class="addnewbtn" @click="addNewClaim()">
            <img src="@/assets/group-5.svg" />
            <b>Add New</b>
          </button>
        </div>
        <tl-accordion class="text-capital" :headerName="headername.details" v-for="headername of list" :key="headername.details">
          <div slot="accordionBody">
            <div class="container-fluid my-2">
              <div class="table-div" ref="table_div" @scroll="onScroll()">
                <data-table
                  :columns="medicalTableColumns"
                  :tableData="headername.items"
                  :showinrow="true"
                  :with-form="false"
                  :showhistory="false"
                  :showdelete="false"
                  @editStart="initEditStart"
                >
                <template v-slot:rowcontent="slotprops">
                  <div v-if="slotprops.value.column.key=='bill'">
                    <span class="attach-content" v-if="slotprops.value.record['bill']">
                      <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                      <a :href="slotprops.value.record['bill']">Attachment</a>
                    </span>
                  </div>
                  <p  v-if="slotprops.value.column.key == 'bill_number'">
            {{ slotprops.value.record.bill_number }}
          </p>
          <p v-if="slotprops.value.column.key == 'bill_date'">
            {{slotprops.value.record.bill_date}}
          </p>
                  <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'bill_amount'">
            {{ formateLess.format(slotprops.value.record.bill_amount) }}
          </p>
          <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'amount_claimed'">
            {{formateLess.format(slotprops.value.record.amount_claimed)}}
          </p>
          <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'amount_approved'">
            {{formateLess.format(slotprops.value.record.amount_approved) }}
          </p>
          <p  v-if="slotprops.value.column.key == 'status'">
            {{slotprops.value.record.status }}
          </p>
                </template>
                </data-table>
              </div>
            </div>
          </div>
        </tl-accordion>
      </div>

      <div v-if="uploadMethod == 'bulkUpload'">
            <div class="download-btn marginbot-20">
              <download-button @downloadTemplate="downloadTemplate" >
                </download-button>
            </div>
            <div class="margin-t-15px" :key="componentKey">
              <upload :tobucket="false" @change="onUploadTemplate($event)"></upload>
            </div>
      </div>
         
      <!-- <div class="bulkUploadClass" v-if="uploadMethod == 'bulkUpload'">
        <div class="download-btn">
          <download-button onclick></download-button>
        </div>
        <div class="margin-t-15px">
          <upload-file @uploadTemplate="onUploadTemplate($event)" />
        </div>
      </div> -->
      <bottom-action-container>
      <btn-grp slot="end">
        <btn text="Back" type="secondary" @click="back" />
      </btn-grp>
    </bottom-action-container>
  </div>
</template>
<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    SearchDropdown,
    selectedEmployeeCard,
  },
  data() {
    return {
      showSuccessBulkUploadMsg: false,
      componentKey: 0,
      toast: false,
      errmsg: "",
      formateLess: "",
      showEmpDetails: false,
      data: {},
      employeeData: [],
      emp_id: null,
      le:null,
      companyValue: false,
      role: "",
      breadcrumbList: [
       {
          name: "Payroll",
         url: `/dashboard/${this.$route.params.entity_index}/payroll`,
        },
        {
         name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`,
       },
        {
          name: "Add New Claim",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`,
       },
      ],
      uploadMethod: "manualUpload",
      headerName: "",
      medicalTableColumns: [
        {
          label: "Bill Number",
          key: "bill_number"
        },
        {
          label: "Bill Date",
          key: "bill_date"
        },
        {
          label: "Bill Amount(₹)",
          key: "bill_amount",
          style:"text-align:right"
        },
        {
          label: "Claim Amount(₹)",
          key: "amount_claimed",
          style:"text-align:right"
        },
        {
          label: "Approved Amount(₹)",
          key: "amount_approved",
          style:"text-align:right"
        },
        {
          label: "Attachment",
          key: "bill"
        },
        {
          label: "Status",
          key: "status"
        }
      ],
      list: [],
      statusObject: {
        pending: "Pending",
        approved: "Approved",
        reject: "Reject"
      }
    };
  },
  mounted() {
    this. formate= new Intl.NumberFormat('en-in',{
        currency: "INR",
        style: "currency"
          });
       this.formateLess= new Intl.NumberFormat('en-in');
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this. formate= new Intl.NumberFormat('en-in',{
        currency: "INR",
        style: "currency"
          });
       this.formateLess= new Intl.NumberFormat('en-in');
    if (this.emp_id) {
      this.getFbpClaimList();
    }
    // this.showEmpDetails = true;
  },

  computed: {
    ...mapState({
      globalEmployeeList: (state) =>
        state.globalapi.globalemployees.entityWiseData,
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    requestParams() {
      return {
        le_id: this.le_id,
      };
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.companyValue) {
          return true;
        } else {
          return false;
        }
      } 
    },
    ifAdmin() {
      return localStorage.getItem("userRole") == "ADMIN" ? true : false;
    },
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
  },

  methods: {
    ...mapActions({
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      fetchAll: "dashboard/payroll/utilities/addnewclaim/fetchAll",
      act_download_fbp_claims: "dashboard/payroll/utilities/addnewclaim/getClaimsTemplate",
      act_upload_fbp_claims: "dashboard/payroll/utilities/addnewclaim/fbpClaimsUploadTemplate"
    }),

    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val,
        });
        this.employeeData = res.data.payload;
        this.emp_id = res.data.payload[0].id;
      } catch (error) {
        // this.toast = true;
        // // this.errmsg = error;
      }
    },
    
    backUpload(){
      this.showSuccessBulkUploadMsg = false;
      this.componentKey += 1;
    },

    async selectedEmp(emp) {
      try {
        this.data = emp;
        this.emp_id = emp.id;
        this.showEmpDetails = true;
        this.list = [];
        this.getFbpClaimList();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    close() {
      this.showEmpDetails = false;
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.companyValue = data.data.user.permissions.company ? true : false;
    },

    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`
      });
      this.showEmpDetails = false;
    },

    addNewClaim() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/addNewClaimFbpComponent`,
        query: { employeeId: this.emp_id }
      });
    },

    async downloadTemplate() {
      try {
        let payload = {
          le_id: this.le_id,
        }
        let res = await this.act_download_fbp_claims();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

   async onUploadTemplate(event) {
      //   let currentMonthEnum = this.financialMonthOptions.find(
      //   item => item.name == this.monthOptions[new Date().getMonth()]
      // ).value;
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.le_id);

      this.$root._data.isSaving = true;
      try {
        let res = await this.act_upload_fbp_claims(formData);
        if (res.data.status) {
          this.responseMsg = res.data.message ? res.data.message : "";
          // this.$refs.bulkFile.uploaded = true;
          // this.$refs.bulkFile.uploading = false;
          this.showSuccessBulkUploadMsg = true;
          this.componentKey += 1
        }else{
          this.toast = true;
          this.errmsg = res.data.message;
          this.componentKey += 1
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to edit an employee */
    initEditStart(rec) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/addNewClaimFbpComponent`,
        query: { fbpClaimId: rec.id }
      });
    },

    async getFbpClaimList() {
      try {
        this.list = [];
        let res = await this.fetchAll(this.emp_id);
        const items = res.data.payload && res.data.payload.length > 0 ? res.data.payload : []
        let headerNames = items.map(i => i.details && i.details.details).filter(x => x);
        headerNames = [...new Set(headerNames)];
        headerNames.forEach(element => {
          let headerData = items.filter(i => i.details && i.details.details === element);
          if (headerData.length > 0) {
            headerData = headerData.map(i => {
              i.status = this.statusObject[i.status]
              if (i.bill_date !== "Invalid date") {
                i.bill_date = new Date(i.bill_date).toISOString().slice(0, 10);
              }
              return i;
            })
            this.list.push({
              details: element,
              items: headerData,
            })
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-bot-22 {
  margin-bottom: 22px;
}
.block-width {
  display: inline-table;
}

.uploadMethoRadio {
  display: flex;
}
.download-btn {
  margin-top: 2%;
}

.add-btn-small {
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;   // Before attribute:flex-end
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}
.text-capital {
  text-transform: capitalize;
}
</style>
